import React from 'react';

import { useDatasetMappedValue } from 'hooks/useDatasetMappedValue';
import { DatasetDataInfo } from "models/dataset-models";
import { formatDuration, formatTime, getDiffSeconds } from "utils/time-utils";
import { formatDatasetValue } from "utils/value-format-utils";
import { InstantDoubleValue } from "api/model/dataset/InstantDoubleValue";

type DatasetTooltipProps = {
	data: InstantDoubleValue | null | undefined;
	time: Date;
	dataset: DatasetDataInfo;
	hide?: boolean;
};

function DatasetTooltipText({data, time, dataset, hide = false}: DatasetTooltipProps) {
    if (hide) {
        return null;
    }
		const mappedValue = useDatasetMappedValue(dataset?.data[0]?.value, dataset.stringValueMapper);
    const fmtTime = formatTime(time);
    const fmtLoadTime = formatTime(dataset?.loadedTime);
    const noData = !(data!);

    let tagValueAge;
    if (+dataset?.loadedTime! > +time!) {
        tagValueAge = <>(age: {formatDuration(getDiffSeconds(dataset?.loadedTime!, time!))} )</>
    } else {
        tagValueAge = <>(age: - {formatDuration(getDiffSeconds(time!, dataset?.loadedTime!))} )</>
    }

    return (
			<>
				<div style={{ whiteSpace: 'pre' }}>
					<div>
						<b>{dataset?.title}:</b>{' '}
						{dataset.stringValueMapper ? (
							<i>
								{mappedValue ? (
									`${data?.value} - ${mappedValue}`
								) : (
									<span className='pi pi-spin pi-spinner' />
								)}
							</i>
						) : (
							<i>
								{formatDatasetValue(dataset, data)}
								{data?.value && ' ' + dataset?.unit}
							</i>
						)}
					</div>
					<div>
						<b>Measurement date:</b> <i>{fmtTime ? fmtTime : 'no data'}</i>
					</div>
					<div>
						<b>Last checked:</b>{' '}
						<i>
							{fmtLoadTime} {!noData ? tagValueAge : ''}
						</i>
					</div>
				</div>
			</>
		);
}

export default DatasetTooltipText;